import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { infoTextCategoria } from "../../actions/configFormularioAction";
import { esborrarErrorAction, uiActualizarTextosStateAction, esborrarOkAction } from "../../actions/ui";
import { ComponenteFormularioTexto } from "./ComponenteFormularioTexto";

const IconChevDown = ({ open }) => (
  <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}
    style={{ transition:'transform 0.2s', transform: open ? 'rotate(180deg)' : 'rotate(0deg)', flexShrink:0 }}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7"/>
  </svg>
);

export const FormularioTextosAdmin = () => {
  const [t, i18n] = useTranslation("generic");
  const dispatch  = useDispatch();
  const navegacio = useNavigate();
  const [cat, setCat]             = useState("1");
  const [primerCop, setPrimerCop] = useState(true);

  const { auth, configFormulario, ui } = useSelector((state) => state);
  const { infoFormulario, infoFormularioTextCategoria } = configFormulario;

  const handleObrirCat = (e, cerrar, id) => {
    e.preventDefault();
    if (id == cat && cerrar) { setCat(null); dispatch(uiActualizarTextosStateAction(1)); }
    else { if (cerrar) dispatch(uiActualizarTextosStateAction(1)); setCat(id); }
    dispatch(esborrarErrorAction());
  };

  useEffect(() => {
    if (primerCop) {
      if (infoFormulario != null) { dispatch(infoTextCategoria(auth.tokenJwt)); dispatch(uiActualizarTextosStateAction(1)); }
      if (infoFormularioTextCategoria != null) {
        setCat(infoFormularioTextCategoria.CatActual);
        dispatch(infoTextCategoria(auth.tokenJwt));
        setPrimerCop(false);
        dispatch(uiActualizarTextosStateAction(1));
      }
    }
  }, [configFormulario, cat]);

  const [disabled] = useState({ cat1:false,cat2:false,cat3:false,cat4:false,cat5:false,cat6:false,cat7:false,cat8:false,cat9:false,cat10:false });

  useEffect(() => {
    if (ui.msgError !== null) setTimeout(() => dispatch(esborrarErrorAction()), 10000);
    if (ui.msgOk    !== null) setTimeout(() => dispatch(esborrarOkAction()),    10000);
  }, [ui]);

  return (
    <div>
      {/* ── Cabecera ──────────────────────────────────────────────── */}
      <div style={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between', gap:16, marginBottom:28, flexWrap:'wrap' }}>
        <div>
          <p className="ca-label-super">Administración</p>
          <h2 className="ca-h2">Modificar Textos</h2>
          <p className="ca-subtext">Edita los textos de cada categoría del formulario</p>
        </div>
      </div>

      {ui.msgError && <div className="ms-alert-error">{ui.msgError}</div>}
      {ui.msgOk    && <div className="ms-alert-success">{ui.msgOk}</div>}

      {/* ── Acordeones ───────────────────────────────────────────── */}
      {infoFormularioTextCategoria != null ? (
        <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
          {Array.from({ length: 9 }, (_, i) => i + 1).map((catIndex) => {
            const isOpen = cat == catIndex.toString();
            const titulo = infoFormularioTextCategoria?.[`Categoria${catIndex}`]?.[`Cat${catIndex}_Titol`];
            return (
              <div key={catIndex} className="fa-accordion" style={{ borderColor: isOpen ? '#111827' : '#e5e7eb' }}>

                <button
                  className="fa-accordion-header"
                  onClick={(e) => handleObrirCat(e, true, catIndex.toString())}
                  disabled={disabled[`cat${catIndex}`]}
                >
                  <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                    <span className="fa-cat-badge" style={{ background: isOpen ? '#111827' : '#f3f4f6', color: isOpen ? '#fff' : '#6b7280' }}>
                      {catIndex}
                    </span>
                    <span className="fa-accordion-title" style={{ color: isOpen ? '#111827' : '#374151' }}>
                      {titulo || `Categoría ${catIndex}`}
                    </span>
                  </div>
                  <IconChevDown open={isOpen} />
                </button>

                {isOpen && (
                  <div style={{ borderTop:'1px solid #f3f4f6' }}>
                    {/* Sub-tabs */}
                    <div className="fa-subtabs" style={{ padding:'12px 20px', background:'#f9fafb', borderBottom:'1px solid #f3f4f6', marginBottom:0 }}>
                      {['Indicadores','Programas'].map((label, i) => {
                        const stateVal = i + 1;
                        const active   = ui.textosState === stateVal;
                        return (
                          <button key={label}
                            className={`fa-subtab${active ? ' active' : ''}`}
                            onClick={(e) => { dispatch(uiActualizarTextosStateAction(stateVal)); handleObrirCat(e, false, catIndex.toString()); }}
                          >{label}</button>
                        );
                      })}
                    </div>
                    <ComponenteFormularioTexto key={`form-category-${catIndex}`} catIndex={catIndex} />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      ) : (
        <div className="u-empty-state">Cargando textos...</div>
      )}
    </div>
  );
};